"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Sprout, Shield, Landmark } from "lucide-react";
const targets = [{
  name: "Organismes de formation",
  desc: "Vous développez des actions de formation et souhaitez créer une certification RNCP/RS, obtenir ou maintenir votre certification Qualiopi®, ou sécuriser votre conformité réglementaire.",
  icon: Sprout
}, {
  name: "Organismes certificateurs",
  desc: "Vous détenez une ou plusieurs certifications et recherchez un accompagnement expert pour structurer vos dispositifs, renouveler vos certifications ou optimiser vos processus de certification.",
  icon: Shield
}, {
  name: "Acteurs institutionnels",
  desc: "Ministères, CPNE : vous portez un projet de certification au service d'une filière ou d'un secteur professionnel.",
  icon: Landmark
}];
export default function Services() {
  return <section data-section-id="174536" id="pourqui" className="w-full flex flex-col bg-background text-foreground ![margin:50px_0px_50px_0px]">
      <div className="w-full !p-0">
        <div className="container mx-auto px-4 md:px-6">
          {/* Titre + intro */}
          <div className="flex flex-col items-center text-center mb-10 md:mb-14 max-w-3xl mx-auto">
            <h2 className="font-serif mb-4 !font-normal !text-[hsl(343,80%,35%)] !text-[42px]">À qui s'adressent les accompagnements d'Effet Conseil ?</h2>
            <p className="text-lg text-muted-foreground font-sans">
              Les services d'Effet Conseil s'adressent aux acteurs engagés
              dans le développement des compétences, partout en France.
            </p>
          </div>

          {/* Cartes */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {targets.map(target => {
            const IconComponent = target.icon;
            return <Card key={target.name} className="text-card-foreground flex flex-col h-full bg-white border-border/50 shadow-sm transition-all duration-300 overflow-hidden rounded-sm !p-0 hover:shadow-xl hover:-translate-y-1">
                  {/* Header bordeaux uniforme */}
                  <CardHeader className="bg-[hsl(343,80%,35%)] flex flex-col items-center justify-center gap-3 py-8 px-6">
                    <IconComponent className="text-white size-10 stroke-[1.5]" />
                    <CardTitle className="text-white font-semibold text-xl font-serif text-center">
                      {target.name}
                    </CardTitle>
                  </CardHeader>

                  {/* Contenu */}
                  <CardContent className="flex-grow flex items-start px-6 py-6">
                    <p className="text-base font-sans text-muted-foreground text-center leading-relaxed">
                      {target.desc}
                    </p>
                  </CardContent>
                </Card>;
          })}
          </div>

          {/* Format d'intervention */}
          <div className="flex items-center justify-center mt-10 md:mt-14">
            <div className="inline-flex items-center justify-center bg-[hsl(343,80%,35%)]/5 border border-[hsl(343,80%,35%)]/15 rounded-sm px-10 py-5">
              <p className="text-lg md:text-xl font-sans font-semibold text-foreground text-center">Présentiel ou distanciel</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}